import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CheckIcon } from "lucide-react";
import { Logo } from "./Logo";
import { footerColumns } from "../data/navigation";
import { container } from "../utils/styles";
export function Footer() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState<"idle" | "error" | "done">("idle");
  const subscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setState("error");
      return;
    }
    setState("done");
  };
  return <footer className="bg-ink text-paper" data-id="element-74" data-mp="36d1st00yll7">
      <div className={`${container} grid gap-8 border-b border-paper/10 py-14 lg:grid-cols-2 lg:items-center lg:py-16`} data-id="element-75" data-mp="3ldalzbekzvhs">
        <div data-id="element-76" data-mp="3qbvm7atu2f68">
          <h2 className="text-3xl font-medium tracking-[-0.03em]" data-id="element-77" data-mp="3qblzbw434o4r">Blijf op de hoogte</h2>
          <p className="mt-2 max-w-md text-[15px] text-paper/60" data-id="element-78" data-mp="29xm24swmjcl7">Nieuwe ontwerpen, acties en inspiratie — af en toe in je inbox.</p>
        </div>
        <form onSubmit={subscribe} noValidate className="w-full lg:justify-self-end lg:max-w-md" data-id="element-79" data-mp="3l9acngdir03d">
          {state === "done" ? <p className="flex items-center gap-2 text-[15px] text-gold-soft" role="status" data-id="element-80" data-mp="3gbikcl8ypbyn">
              <CheckIcon className="h-4 w-4" data-id="element-81" data-mp="3v8rgds97n3wp" /> Bedankt, je bent ingeschreven.
            </p> : <>
              <div className="flex gap-2" data-id="element-82" data-mp="3q7bvq1ay2zeu">
                <label htmlFor="newsletter" className="sr-only" data-id="element-83" data-mp="82qt3uy8hxus">
                  E-mailadres
                </label>
                <input id="newsletter" type="email" value={email} onChange={e => {
              setEmail(e.target.value);
              setState("idle");
            }} placeholder="Je e-mailadres" aria-invalid={state === "error"} className="h-12 min-w-0 flex-1 rounded-full bg-paper/10 px-5 text-sm text-paper placeholder:text-paper/45 transition-colors duration-150 focus:bg-paper/15 focus:outline-none focus:ring-2 focus:ring-gold-soft/60" data-id="element-84" data-mp="34p997szhui9" />
                <button type="submit" className="h-12 shrink-0 rounded-full bg-paper px-6 text-sm font-medium text-ink transition-colors duration-150 hover:bg-gold-soft" data-id="element-85" data-mp="yv92dnui3qt4">
                  Inschrijven
                </button>
              </div>
              {state === "error" && <p className="mt-2 px-2 text-xs text-red-300" data-id="element-86" data-mp="1cluodlf94gv8">Vul een geldig e-mailadres in.</p>}
            </>}
        </form>
      </div>

      <div className={`${container} grid gap-10 py-14 lg:grid-cols-12`} data-id="element-87" data-mp="1hj4b2tb9aefd">
        <div className="lg:col-span-4" data-id="element-88" data-mp="1mjim8k85m4hm">
          <Logo inverted data-id="element-89" data-mp="1mkju6ftviav4" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-paper/60" data-id="element-90" data-mp="1riv4ssrzspee">Custom ontworpen. Met aandacht geproduceerd. Lampen, woondecoratie en persoonlijke cadeaus uit Nederland.</p>
        </div>
        <nav aria-label="Footer" className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-8" data-id="element-91" data-mp="3ta8b9m9lz5ck">
          {footerColumns.map(col => <div key={col.title} data-id="element-92" data-mp="2ag5d6l9xj2e0">
              <h3 className="text-sm font-medium text-paper" data-id="element-93" data-mp="2ah84gub5z6ug">{col.title}</h3>
              <ul className="mt-4 space-y-3" data-id="element-94" data-mp="25mu6ck54alm3">
                {col.links.map(l => <li key={l.label} data-id="element-95" data-mp="21nlddhhwirrl">
                    <Link to={l.to} className="text-sm text-paper/60 transition-colors duration-150 hover:text-paper" data-id="element-96" data-mp="21kfn3yxjdjua">
                      {l.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}
        </nav>
      </div>

      <div className="border-t border-paper/10" data-id="element-97" data-mp="2pa9z6ea174dh">
        <div className={`${container} flex flex-col gap-2 py-6 text-xs text-paper/45 sm:flex-row sm:items-center sm:justify-between`} data-id="element-98" data-mp="2kci8top1bqbe">
          <p data-id="element-99" data-mp="2fdowhzlhi5ct">© {new Date().getFullYear()} Koers Design. Alle rechten voorbehouden.</p>
          <p data-id="element-100" data-mp="18yxlh32nd452">Ontworpen en geproduceerd in Nederland</p>
        </div>
      </div>
    </footer>;
}